import { render, staticRenderFns } from "./SpecialDiscounts.vue?vue&type=template&id=24bed6ef&"
import script from "./SpecialDiscounts.vue?vue&type=script&lang=js&"
export * from "./SpecialDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports